var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCyprus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3044 17.3914C30.6957 17.3914 29.9421 17.3914 28.6957 17.3914C28.6957 22.1939 24.8024 26.087 20.0001 26.087C15.1975 26.087 11.3045 22.1939 11.3045 17.3914C10.4638 17.3914 9.53627 17.3914 8.6958 17.3914C8.6958 22.5644 12.1705 26.9259 16.9135 28.2691C16.3935 29.2569 16.4727 30.5006 17.2155 31.4275C18.1911 30.6456 19.2012 29.8361 20.0581 29.1496C20.9149 29.8362 21.9251 30.6457 22.9006 31.4275C23.6508 30.4914 23.7246 29.2319 23.1874 28.2393C27.8784 26.8632 31.3044 22.5276 31.3044 17.3914V17.3914Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0435 16.5217C13.0435 16.5217 13.0435 20.8695 17.3913 20.8695L18.2608 21.7391H19.9999C19.9999 21.7391 20.8695 19.1304 22.6086 19.1304C22.6086 19.1304 22.6086 17.3912 24.3478 17.3912C26.0869 17.3912 26.9564 17.3912 26.9564 17.3912C26.9564 17.3912 26.0869 13.913 30.4347 11.3043L28.6956 10.4348C28.6956 10.4348 22.6086 14.7826 18.2608 13.913V15.6522H16.5217L15.6521 14.7826L13.0435 16.5217Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyprus);
export default __webpack_public_path__ + "static/media/cyprus.d5a08e0c8532478ae779df0db5ce9df6.svg";
export { ForwardRef as ReactComponent };